import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import {
  ProductTilesState,
  ProductTileType,
} from 'b2b-apps/shop/product/redux/products/tile/types';

const getState = (state: State): ProductTilesState => state.product.products.tile;

const getProducts = (state: State): ProductTilesState => getState(state) || {};

const getProductsTiles = (
  state: State,
): Record<string, RemoteRecord<ProductTileType>> => {
  const products = getProducts(state);
  return Object.keys(products).reduce(
    (productRecords: Record<string, any>, sku: string) => ({
      ...productRecords,
      [sku]: new RemoteRecord(products[sku]),
    }),
    {},
  );
};

const getProductTileBySku = (
  state: State,
  sku: string,
): RemoteRecord<ProductTileType> => new RemoteRecord(getProducts(state)[sku]);

const getProductsBySkus = (
  state: State,
  skus: string[],
): Record<string, RemoteRecord<ProductTileType>> => {
  const products = getProducts(state);
  return skus.reduce(
    (productRecords: Record<string, any>, sku: string) => ({
      ...productRecords,
      [sku]: new RemoteRecord(products[sku]),
    }),
    {},
  );
};

export {
  getProducts,
  getProductsBySkus,
  getProductsTiles,
  getProductTileBySku,
  getState,
};
